import { render } from "./text-ellipsis.vue?vue&type=template&id=61f4bd5a&scoped=true"
import script from "./text-ellipsis.vue?vue&type=script&lang=js"
export * from "./text-ellipsis.vue?vue&type=script&lang=js"

import "./text-ellipsis.vue?vue&type=style&index=0&id=61f4bd5a&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f4bd5a"]])

export default __exports__